var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","padding":"20px","background":"#fafafa","color":"#212529","font-size":"16px","font-weight":"700","text-align":"center","text-transform":"uppercase"}},[_vm._v(" Weather widget block ")])
}
var staticRenderFns = []

export { render, staticRenderFns }